import * as React from "react";
import TextField from "@mui/material/TextField";
import AdapterJalali from "@date-io/date-fns-jalali";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { parseApiLocalDateTime } from "../../../middleware/middleware";

const JalaliDateTimePicker = ({
  value,
  label,
  onChange,
  disabled = false,
  size = "medium",
  minDate,
  maxDate,
  disablePortal = false,
  ...other
}) => {
  const dateValue = React.useMemo(() => {
    if (!value) return null;
    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }
    return parseApiLocalDateTime(value);
  }, [value]);

  return (
    <LocalizationProvider dateAdapter={AdapterJalali}>
      <DateTimePicker
        mask="____/__/__ __:__"
        value={dateValue}
        label={label}
        minDate={minDate || undefined}
        maxDate={maxDate || undefined}
        onChange={(newValue) => {
          onChange(newValue);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            {...other}
            size={size}
            error={Boolean(other.error ?? params.error)}
            helperText={
              other.helperText !== undefined && other.helperText !== false
                ? other.helperText
                : params.helperText
            }
            InputProps={{
              ...params.InputProps,
              ...other.InputProps,
              readOnly: Boolean(other.readOnly || other.disabled),
            }}
            FormHelperTextProps={{
              ...params.FormHelperTextProps,
              ...other.FormHelperTextProps,
              sx: {
                ...(params.FormHelperTextProps?.sx || {}),
                ...(other.FormHelperTextProps?.sx || {}),
                color: (other.error ?? params.error)
                  ? "error.main"
                  : undefined,
              },
            }}
          />
        )}
        disabled={disabled}
        PopperProps={{
          disablePortal,
          placement: "bottom-start",
          sx: {
            // بالای Dialog (zIndex.modal ≈ 1300) تا تقویم دیده و قابل کلیک باشد
            zIndex: (theme) => (theme?.zIndex?.modal ?? 1300) + 2,
          },
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "viewport",
                altAxis: true,
                tether: false,
              },
            },
            {
              name: "flip",
              options: {
                fallbackPlacements: ["top-start", "bottom-end"],
              },
            },
          ],
        }}
        DialogProps={{
          disableScrollLock: true,
          sx: {
            zIndex: (theme) => (theme?.zIndex?.modal ?? 1300) + 2,
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default JalaliDateTimePicker;
